export default "/images/a7275a95bdd27ad454afab582d0d60cf.avif";